import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@material-ui/lab";
import { DataTypeProvider } from "@devexpress/dx-react-grid";
import { http } from "../../services/http";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(0.4),
  },
  listbox: {
    maxHeight: 300,
    overflow: "auto",
  },
}));

const ProcedimentoAacdFormatter = ({ value }) => {
  const classes = useStyles();
  return <TextField className={classes.root} value={value || ""} InputProps={{ disableUnderline: true }} />;
};

const ProcedimentoAacdEditor = ({ value, onValueChange, row }) => {
  const [options, setOptions] = useState([]);
  const classes = useStyles();
  const [inputValue, setInputValue] = useState("");
  const [timer, setTimer] = useState(null);
  const [open, setOpen] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const isFilterContext = !row;

  useEffect(() => {
    if (!initialized && value) {
      setInputValue(value);
      setInitialized(true);
    }
  }, [value, initialized]);

  useEffect(() => {
    if (initialized && value && value !== inputValue) {
      setInputValue(value);
      setOpen(false);
    }
  }, [value, initialized, inputValue]);

  function searchProcedimentos(searchText) {
    if (searchText.length < 1) {
      setOptions([]);
      setOpen(false);
      return;
    }

    http
      .get(`carga-aacd/procedures/search-by-name?search=${searchText}`)
      .then((response) => {
        if (response?.status === 200) {
          const results = response?.data || [];
          setOptions(results);
          setOpen(results.length > 0);
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar procedimentos:", error);
        setOptions([]);
        setOpen(false);
      });
  }

  function handleInputChange(event, newInputValue) {
    setInputValue(newInputValue);
    onValueChange(newInputValue);

    if (isFilterContext) {
      return;
    }

    clearTimeout(timer);
    setTimer(
      setTimeout(function () {
        searchProcedimentos(newInputValue);
      }, 300)
    );
  }

  function handleChange(event, newValue) {
    if (newValue && typeof newValue === "object") {
      setInputValue(newValue.name);
      onValueChange(newValue.name);

      if (newValue.tuss_code && window.updateRowField) {
        const rowId = row && row.id !== undefined ? row.id : 0;
        setTimeout(() => {
          window.updateRowField(rowId, "codigo_d2i", newValue.tuss_code);
        }, 200);
      }

      setOpen(false);
    }
  }

  if (isFilterContext) {
    return (
      <div className={classes.root}>
        <TextField
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value);
            onValueChange(e.target.value);
          }}
          label=""
          variant="standard"
          size="small"
        />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <Autocomplete
        freeSolo
        open={open}
        onOpen={() => {
          if (options.length > 0 && inputValue.length > 0) {
            setOpen(true);
          }
        }}
        onClose={() => setOpen(false)}
        options={options}
        inputValue={inputValue}
        size="small"
        ListboxProps={{
          className: classes.listbox,
          style: { maxHeight: 300 },
        }}
        getOptionLabel={(option) => {
          if (typeof option === "string") {
            return option;
          }
          return option?.name || "";
        }}
        onInputChange={handleInputChange}
        onChange={handleChange}
        renderInput={(params) => <TextField {...params} label="" variant="standard" />}
      />
    </div>
  );
};

export const ProcedimentoAacdTypeProvider = (props) => (
  <DataTypeProvider formatterComponent={ProcedimentoAacdFormatter} editorComponent={ProcedimentoAacdEditor} {...props} />
);
